var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"subscribe-form"},[(_vm.currentStep === _vm.STEPS.FIRST_STEP)?_c('first',{attrs:{"config":_vm.configFirst},on:{"success":_vm.onSuccess}}):(_vm.currentStep === _vm.STEPS.THANK_YOU_STEP)?_c('thank-you',{attrs:{"config":_vm.configThankYou}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }